"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
exports.AUTO = -1;
var GeneLayout = /** @class */ (function () {
    function GeneLayout(data, virusLen, rh) {
        this.minGap = 50;
        this.data = data;
        this.virusLen = virusLen;
        this.rowHeight = rh;
    }
    GeneLayout.prototype.prepare = function () {
        this.maxRow = 0;
        this.rows = [-9999];
        for (var _i = 0, _a = this.data; _i < _a.length; _i++) {
            var i = _a[_i];
            if (i.end < i.start) {
                i.overflow = 1;
                // add overflow data
                this.data.push({
                    start: i.start - this.virusLen,
                    end: i.end,
                    direction: i.direction,
                    name: i.name,
                    subtype: i.subtype,
                    full_name: i.full_name,
                    color: i.color,
                    overflow: -1,
                    exon_amount: 0,
                    exons: [], cds_regions: [],
                    gene_name: "",
                    biotype: "",
                });
                // make end > start
                i.end = this.virusLen + i.end;
            }
            else if (i.overflow !== -1) {
                i.overflow = 2;
            }
        }
        this.data.sort(function (g1, g2) { return g1.start - g2.start; });
        this.yPos = {};
    };
    GeneLayout.prototype.run = function () {
        this.prepare();
        var currOK;
        for (var _i = 0, _a = this.data; _i < _a.length; _i++) {
            var i = _a[_i];
            currOK = false;
            for (var j = 0; j < this.maxRow + 1; j++) {
                if (this.rows[j] + this.minGap <= i.start) { // can place at this row
                    this.rows[j] = i.end;
                    this.yPos[i.name] = this.rowHeight * j;
                    currOK = true;
                    break;
                }
            }
            if (!currOK) { // need a new row
                this.maxRow++;
                this.rows[this.maxRow] = i.end;
                this.yPos[i.name] = this.rowHeight * this.maxRow;
            }
        }
        this.maxYPos = this.maxRow * this.rowHeight;
    };
    return GeneLayout;
}());
exports.GeneLayout = GeneLayout;
var Gravity;
(function (Gravity) {
    Gravity[Gravity["Top"] = 0] = "Top";
    Gravity[Gravity["Right"] = 1] = "Right";
    Gravity[Gravity["Bottom"] = 2] = "Bottom";
    Gravity[Gravity["Left"] = 3] = "Left";
})(Gravity = exports.Gravity || (exports.Gravity = {}));
var Direction;
(function (Direction) {
    Direction[Direction["Horizontal"] = 0] = "Horizontal";
    Direction[Direction["Vertical"] = 1] = "Vertical";
})(Direction = exports.Direction || (exports.Direction = {}));
/* Extensions */
d3.selection.prototype.appendG =
    function (cls, transform) {
        if (transform) {
            return this.append("g").attr("class", cls).attr("transform", transform);
        }
        else {
            return this.append("g").attr("class", cls);
        }
    };
d3.selection.prototype.prependG =
    function (cls, transform) {
        if (transform) {
            return this.insert("g", ":first-child").attr("class", cls).attr("transform", transform);
        }
        else {
            return this.insert("g", ":first-child").attr("class", cls);
        }
    };
d3.selection.prototype.appendLine =
    function (cls, x1, y1, x2, y2) {
        return this.append("line").attr("class", cls).attr("x1", x1).attr("x2", x2).attr("y1", y1).attr("y2", y2);
    };
d3.selection.prototype.appendRect =
    function (cls, x, y, w, h) {
        return this.append("rect").attr("class", cls).attr("x", x).attr("y", y).attr("width", w).attr("height", h);
    };
d3.selection.prototype.appendCircle =
    function (cls, cx, cy, r) {
        return this.append("circle").attr("class", cls).attr("cx", cx).attr("cy", cy).attr("r", r);
    };
d3.selection.prototype.appendText =
    function (cls, x, y, txt, anchor) {
        if (anchor) {
            return this.append("text").attr("class", cls).attr("x", x).attr("y", y).text(txt).attr("text-anchor", anchor);
        }
        else {
            return this.append("text").attr("class", cls).attr("x", x).attr("y", y).text(txt);
        }
    };
//# sourceMappingURL=defs.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/defs.js
// module id = 880
// module chunks = 0 1